"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("../classnames"));
var locales = __importStar(require("../locales.json"));
var PlainButton_1 = __importDefault(require("./buttons/PlainButton"));
var getPrevMonthFillValues = function (visible) {
    var daysInPrevMonth = new Date(visible.year, visible.month, 0).getDate();
    var firstDayOfWeek = new Date(visible.year, visible.month, 1).getDay();
    var values = [];
    var prevYear = visible.year - (visible.month === 0 ? 1 : 0);
    var prevMonth = (visible.month - 1 + 12) % 12;
    for (var idx = firstDayOfWeek - 1; idx >= 0; idx -= 1) {
        values.push({ year: prevYear, month: prevMonth, day: daysInPrevMonth - idx, fill: true });
    }
    return values;
};
var getCurrentMonthValues = function (visible) {
    var maxDay = new Date(visible.year, visible.month + 1, 0).getDate();
    var values = [];
    for (var day = 1; day <= maxDay; day += 1) {
        values.push({ year: visible.year, month: visible.month, day: day, fill: false });
    }
    return values;
};
var getNextMonthFillValues = function (visible) {
    var lastDayOfWeek = new Date(visible.year, visible.month + 1, 0).getDay();
    var values = [];
    var nextYear = visible.year + (visible.month === 11 ? 1 : 0);
    var nextMonth = (visible.month + 1) % 12;
    for (var idx = lastDayOfWeek; idx < 6; idx += 1) {
        values.push({ year: nextYear, month: nextMonth, day: idx - lastDayOfWeek + 1, fill: true });
    }
    return values;
};
var makeActiveHash = function (year, month, day) {
    if (year !== null && month !== null && day !== null) {
        return year + "-" + month + "-" + day;
    }
    var today = new Date();
    return today.getFullYear() + "-" + today.getMonth() + "-" + today.getDate();
};
var Calendar = function (_a) {
    var _b = _a.year, year = _b === void 0 ? null : _b, _c = _a.month, month = _c === void 0 ? null : _c, _d = _a.day, day = _d === void 0 ? null : _d, onChange = _a.onChange;
    var _e = react_1.useState(function () { return ({
        year: year === null ? new Date().getFullYear() : year,
        month: month === null ? new Date().getMonth() : month
    }); }), visible = _e[0], setVisible = _e[1];
    react_1.useEffect(function () {
        if ((year !== null)
            && (month !== null)
            && ((year !== visible.year) || (month !== visible.month))) {
            setVisible({ year: year, month: month });
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [year, month]);
    var onPrevMonthClick = function () { return setVisible(function (current) {
        var nextVisible = new Date(current.year, current.month - 1, 1);
        return { year: nextVisible.getFullYear(), month: nextVisible.getMonth() };
    }); };
    var onNextMonthClick = function () { return setVisible(function (current) {
        var nextVisible = new Date(current.year, current.month + 1, 1);
        return { year: nextVisible.getFullYear(), month: nextVisible.getMonth() };
    }); };
    var activeHash = makeActiveHash(year, month, day);
    var values = react_1.useMemo(function () { return __spreadArrays(getPrevMonthFillValues(visible), getCurrentMonthValues(visible), getNextMonthFillValues(visible)); }, [visible]);
    var monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    return (react_1.default.createElement("div", { className: "chq-cal" },
        react_1.default.createElement("div", { className: "chq-cal--head" },
            react_1.default.createElement("button", { type: "button", className: "chq-cal--head--prev", onClick: onPrevMonthClick, "aria-label": locales.en.calendar.nav.prev },
                react_1.default.createElement("em", { className: "chq-cal--head--ct" }),
                "\u00A0"),
            react_1.default.createElement("button", { type: "button", className: "chq-cal--head--next", onClick: onNextMonthClick, "aria-label": locales.en.calendar.nav.next },
                react_1.default.createElement("em", { className: "chq-cal--head--ct" }),
                "\u00A0"),
            react_1.default.createElement("div", { className: "chq-cal--head--lbl" },
                locales.en.calendar.monthNames[visible.month],
                " ",
                visible.year)),
        react_1.default.createElement("div", { className: "chq-cal--months" }, locales.en.calendar.dayAbbrs.map(function (abbr) { return (react_1.default.createElement("strong", { key: abbr }, abbr)); })),
        react_1.default.createElement("div", { className: "chq-cal--days" }, values.map(function (value) {
            var valueHash = value.year + "-" + value.month + "-" + value.day;
            var onClick = function () { return onChange(value.year, value.month, value.day); };
            var className = classnames_1.default("chq-cal--day", {
                "chq-cal--day-act": (valueHash === activeHash),
                "chq-cal--day-out": value.fill
            });
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { id: value.month + "-" + value.day + "-" + value.year, style: { display: "none" } },
                    monthNames[value.month],
                    " ",
                    value.day,
                    ", ",
                    value.year),
                react_1.default.createElement(PlainButton_1.default, { key: valueHash, className: className, onClick: onClick, "aria-labelledby": value.month + "-" + value.day + "-" + value.year }, value.day)));
        }))));
};
exports.default = Calendar;
